
      import Organize from './organize.vue'
      import type { App, Plugin } from 'vue'

      export const OrganizePlugin: Plugin = {
        install(app: App) {
          app.component('Organize', Organize)
        },
      }
      export { Organize }
      